<template>
	<li :class="['timeline-item', { 'timeline-item--future': isFuture }]">
		<SvgIcon
			class="timeline-item__dot"
			icon="dot"
			:color="isFuture ? 'light-grey' : 'gold'"
		/>
		<div class="timeline-item__year">{{ year }}</div>
		<div class="timeline-item__title">{{ title }}</div>
		<SvgIcon
			class="timeline-item__icon"
			v-if="isActive"
			icon="asterisk"
			color="gold"
		/>
	</li>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const year = computed(() => props.fields?.year?.value);
const title = computed(() => props.fields?.title?.value);
const isActive = computed(() => props.fields?.isActive?.value);
const isFuture = computed(() => props.fields?.isFuture?.value);
</script>

<style lang="scss">
.timeline-item {
	display: flex;
	align-items: flex-start;
	gap: var(--spacing-1, 8px);
	border-left: 1px solid var(--color-light-grey, #767676);
	padding: var(--spacing-3, 16px) 0;

	.timeline-item__dot {
		width: 8px;
		min-width: 8px;
		height: 8px;
		min-width: 8px;
		min-height: 8px;
		margin-left: -4px;
		margin-top: 8px;
	}

	.timeline-item__year {
		color: var(--color-gold, #8d723e);
		font-size: var(--text-base, 16px);
		font-weight: 300;
		line-height: 140%;
	}

	.timeline-item__title {
		color: var(--color-white, #fff);
		font-size: var(--text-sm, 14px);
		font-weight: 400;
		line-height: 140%;
		margin-top: 2px;
	}

	.timeline-item__icon {
		width: 12px;
		height: 12px;
		flex-shrink: 0;
		margin-left: auto;
		margin-top: 6px;
	}

	&:has(+ .timeline-item--future) {
		border-image: linear-gradient(
				to bottom,
				var(--color-light-grey, #767676) 0%,
				var(--color-light-grey, #767676) 50%,
				transparent 100%
			)
			1 100%;
	}

	&:first-child {
		border-image: linear-gradient(
				to top,
				var(--color-light-grey, #767676) 50%,
				transparent 50%
			)
			1 100%;
	}

	&:last-child {
		border-image: linear-gradient(
				to bottom,
				var(--color-light-grey, #767676) 50%,
				transparent 50%
			)
			1 100%;
	}
}

.timeline-item--future {
	border: none;
}
</style>
